var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume"},_vm._l((_vm.resume),function(item,index){return _c('div',{key:`${_vm.resumeId}-item-${index}`,staticClass:"resume__item"},[_c('div',{staticClass:"resume__label"},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"resume__value"},[_vm._v(_vm._s(item.value || '--'))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }